/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Portals_Connected_WaitingInputs */

const cs_listing_portals_connected_waiting = /** @type {(inputs: Listing_Portals_Connected_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeká na údaje`)
};

const en_listing_portals_connected_waiting = /** @type {(inputs: Listing_Portals_Connected_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for credentials`)
};

/**
* | output |
* | --- |
* | "Waiting for credentials" |
*
* @param {Listing_Portals_Connected_WaitingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const listing_portals_connected_waiting = /** @type {((inputs?: Listing_Portals_Connected_WaitingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Portals_Connected_WaitingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_portals_connected_waiting(inputs)
	return cs_listing_portals_connected_waiting(inputs)
});